(function () {
  'use strict';
  var mediaControllers = new Map();
  var rowControllers = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 767px)');
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var saveData = Boolean(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
  var apple = /iPad|iPhone|iPod/.test(navigator.userAgent) || (/Mac/.test(navigator.platform) && navigator.maxTouchPoints > 1) || (/Safari/.test(navigator.userAgent) && !/Chrome|Chromium|Edg|OPR/.test(navigator.userAgent));

  function listenQuery(query, fn) {
    if (query.addEventListener) query.addEventListener('change', fn);
    else query.addListener(fn);
  }
  function selectAll(root, selector) {
    var items = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.nodeType === 1 && root.matches(selector)) items.unshift(root);
    return items;
  }
  function parseSources(value) {
    try { var sources = JSON.parse(value || 'null'); return Array.isArray(sources) ? sources : []; } catch (_) { return []; }
  }
  function selectMp4(sources, width) {
    var videos = sources.filter(function (s) { return s.mime_type === 'video/mp4' || s.mimeType === 'video/mp4' || s.format === 'mp4'; });
    videos.sort(function (a, b) { return (a.width || 0) - (b.width || 0); });
    return videos.find(function (s) { return s.width >= width; }) || videos[videos.length - 1];
  }
  function inViewport(el, margin) {
    var rect = el.getBoundingClientRect();
    return rect.bottom > -margin && rect.top < window.innerHeight + margin && rect.right > 0 && rect.left < window.innerWidth;
  }
  function initMedia(frame) {
    if (mediaControllers.has(frame)) return;
    var video = frame.querySelector('video');
    var control = frame.querySelector('[data-media-control]');
    var poster = frame.querySelector('.af-video-poster');
    var hero = frame.getAttribute('data-hero') === 'true';
    var autoplay = frame.getAttribute('data-autoplay') === 'true';
    var loaded = false;
    var disposed = false;
    var pending = false;
    var manual = false;
    var userPaused = false;
    var failed = false;
    var timeout = 0;
    var observers = [];

    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    function updateControl() {
      var playing = !video.paused && !video.ended;
      frame.classList.toggle('af-playing', playing);
      control.setAttribute('aria-label', control.getAttribute(playing ? 'data-pause-label' : 'data-play-label'));
    }
    function pickSource() {
      var desktop = parseSources(frame.getAttribute('data-desktop-sources'));
      var small = parseSources(frame.getAttribute('data-mobile-sources'));
      var mobileFallback = frame.getAttribute('data-mp4-mobile');
      if (mobile.matches && !small.length && mobileFallback) return mobileFallback;
      var source = selectMp4(mobile.matches && small.length ? small : desktop, Math.min(mobile.matches ? 960 : 1600, Math.ceil(frame.clientWidth * Math.min(window.devicePixelRatio || 1, 2))));
      if (source) return source.url;
      if (frame.getAttribute('data-mp4')) return frame.getAttribute('data-mp4');
      if (!hero) return '';
      var family = apple && video.canPlayType('video/quicktime; codecs="hvc1"') ? 'hevc' : 'webm';
      if (family === 'webm' && !video.canPlayType('video/webm; codecs="vp9"')) return '';
      return (mobile.matches && frame.getAttribute('data-' + family + '-mobile')) || frame.getAttribute('data-' + family) || '';
    }
    function load() {
      if (loaded || disposed) return;
      var src = pickSource();
      if (!src) { control.hidden = true; failed = true; return; }
      loaded = true;
      video.src = src;
      video.preload = 'metadata';
      video.load();
    }
    function allowed() {
      return !disposed && !failed && !userPaused && document.visibilityState !== 'hidden' && inViewport(frame, 0) && (manual || (autoplay && !reduced.matches && !saveData));
    }
    function play() {
      if (!allowed() || pending || (!video.paused && !video.ended)) return;
      load();
      if (failed) return;
      pending = true;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(function () { pending = false; updateControl(); }, 10000);
      try {
        var attempt = video.play();
        if (attempt && attempt.then) attempt.then(function () {
          pending = false;
          window.clearTimeout(timeout);
          if (!allowed()) video.pause();
          updateControl();
        }).catch(function () { pending = false; window.clearTimeout(timeout); updateControl(); });
        else pending = false;
      } catch (_) { pending = false; updateControl(); }
    }
    function update() {
      if (disposed) return;
      if (!allowed()) { if (!video.paused) video.pause(); return; }
      play();
    }
    function reveal() {
      if (video.readyState >= 2) frame.classList.add('af-has-frame');
      updateControl();
    }
    function onError() {
      failed = true;
      pending = false;
      window.clearTimeout(timeout);
      frame.classList.remove('af-has-frame', 'af-playing');
      control.hidden = true;
    }
    function onClick() {
      if (!video.paused) {
        userPaused = true;
        video.pause();
      } else {
        manual = true;
        userPaused = false;
        failed = false;
        play();
      }
      updateControl();
    }
    function begin() {
      if (disposed) return;
      if ('IntersectionObserver' in window) {
        var nearby = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting && autoplay && !reduced.matches && !saveData) load(); });
        }, { rootMargin: '160px 0px' });
        var visible = new IntersectionObserver(function () { update(); }, { threshold: [0, 0.15, 0.5] });
        nearby.observe(frame); visible.observe(frame); observers.push(nearby, visible);
      }
      update();
    }
    video.addEventListener('playing', reveal);
    video.addEventListener('pause', updateControl);
    video.addEventListener('error', onError);
    video.addEventListener('canplay', update);
    control.addEventListener('click', onClick);
    if (hero && poster && !poster.complete) {
      poster.addEventListener('load', begin, { once: true });
      poster.addEventListener('error', begin, { once: true });
    } else begin();
    mediaControllers.set(frame, {
      update: update,
      pause: function () { video.pause(); },
      destroy: function () {
        disposed = true;
        observers.forEach(function (observer) { observer.disconnect(); });
        window.clearTimeout(timeout);
        video.pause();
        video.removeAttribute('src');
        video.load();
        control.removeEventListener('click', onClick);
        video.removeEventListener('playing', reveal);
        video.removeEventListener('pause', updateControl);
        video.removeEventListener('error', onError);
        video.removeEventListener('canplay', update);
        if (poster) { poster.removeEventListener('load', begin); poster.removeEventListener('error', begin); }
      }
    });
  }
  function initRow(row) {
    if (rowControllers.has(row)) return;
    var track = row.querySelector('.customization-card-row');
    var left = row.querySelector('[data-scroll="-1"]');
    var right = row.querySelector('[data-scroll="1"]');
    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var position = Math.max(0, Math.min(track.scrollLeft, max));
      left.disabled = position <= 1;
      right.disabled = max - position <= 1;
    }
    function scroll(event) {
      var delta = Number(event.currentTarget.getAttribute('data-scroll')) * track.clientWidth * 0.8;
      if (track.scrollBy) track.scrollBy({ left: delta, behavior: reduced.matches ? 'auto' : 'smooth' });
      else track.scrollLeft += delta;
    }
    track.addEventListener('scroll', update, { passive: true });
    left.addEventListener('click', scroll); right.addEventListener('click', scroll);
    var observer = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
    if (observer) observer.observe(track);
    update();
    rowControllers.set(row, { update: update, destroy: function () { if (observer) observer.disconnect(); track.removeEventListener('scroll', update); left.removeEventListener('click', scroll); right.removeEventListener('click', scroll); } });
  }
  function updateLike(button, liked) {
    button.setAttribute('aria-pressed', String(liked));
    button.setAttribute('aria-label', button.getAttribute(liked ? 'data-unlike-label' : 'data-like-label'));
    button.querySelector('.customization-like-count').textContent = liked ? '1' : '0';
  }
  function initLikes(root) {
    selectAll(root, '[data-like-key]').forEach(function (button) {
      var liked = false;
      try { liked = window.localStorage.getItem('artifex-like:' + button.getAttribute('data-like-key')) === '1'; } catch (_) {}
      updateLike(button, liked);
    });
  }
  function toggleLike(button) {
    var liked = button.getAttribute('aria-pressed') !== 'true';
    updateLike(button, liked);
    try {
      var key = 'artifex-like:' + button.getAttribute('data-like-key');
      if (liked) window.localStorage.setItem(key, '1');
      else window.localStorage.removeItem(key);
    } catch (_) {}
  }
  function init(root) {
    selectAll(root, '[data-af-media]').forEach(initMedia);
    selectAll(root, '[data-accessory-row]').forEach(initRow);
    initLikes(root);
  }
  function refresh() { mediaControllers.forEach(function (controller) { controller.update(); }); }
  function closeMenu() {
    document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      var menu = document.getElementById(button.getAttribute('aria-controls'));
      if (menu) menu.classList.remove('main-nav--open');
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-menu-toggle]');
    if (button) {
      var expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(expanded));
      document.getElementById(button.getAttribute('aria-controls')).classList.toggle('main-nav--open', expanded);
    } else if (event.target.closest('.main-nav a') || !event.target.closest('.site-header')) closeMenu();
    var like = event.target.closest('[data-like-key]');
    if (like) toggleLike(like);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var openToggle = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
      closeMenu();
      if (openToggle) openToggle.focus();
    }
  });
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('pagehide', function () { mediaControllers.forEach(function (controller) { controller.pause(); }); });
  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () { document.documentElement.style.setProperty('--af-vh', window.innerHeight * .01 + 'px'); refresh(); }, 250);
  });
  window.addEventListener('resize', function () { rowControllers.forEach(function (controller) { controller.update(); }); refresh(); });
  if (!('IntersectionObserver' in window)) window.addEventListener('scroll', refresh, { passive: true });
  listenQuery(reduced, refresh);
  listenQuery(mobile, function () { closeMenu(); refresh(); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    [mediaControllers, rowControllers].forEach(function (map) {
      map.forEach(function (controller, node) { if (event.target.contains(node)) { controller.destroy(); map.delete(node); } });
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target.closest('details');
    if (details) details.open = true;
    var card = event.target.closest('.customization-card');
    if (card) card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
  });
  var testFlex = document.createElement('div');
  testFlex.style.cssText = 'position:absolute;visibility:hidden;display:flex;flex-direction:column;row-gap:1px;';
  testFlex.appendChild(document.createElement('div'));
  testFlex.appendChild(document.createElement('div'));
  document.body.appendChild(testFlex);
  if (testFlex.scrollHeight !== 1) document.documentElement.classList.add('af-no-flex-gap');
  testFlex.remove();
  init(document);
})();
